import { URL_REGEX } from '@/common/constants';
import { TranslationFunctionType } from '@/common/types';
import { array, boolean, date, object, string } from 'yup';

export const securityCultureSchema = (
  t: TranslationFunctionType,
  useQuizEngine: boolean,
) =>
  object().shape({
    targets: array().min(1, t('error.requiredField')),
    url: useQuizEngine
      ? string().nullable()
      : string()
          .matches(URL_REGEX || '' || null, t('error.invalidUrl'))
          .required(t('error.requiredField')),
  });

export const securityCultureUploadSurveySchema = (
  t: TranslationFunctionType,
  isDemo?: boolean,
) =>
  object().shape({
    published: boolean(),
    file: object().when(['published'], (_, schema) =>
      isDemo ? schema.required(t('error.requiredFile')) : schema.notRequired(),
    ),
    targets: isDemo ? array() : array().min(1, t('error.requiredField')),
    date: isDemo ? date() : date().required(t('error.requiredField')),
  });

export const securityCultureSelfServiceSchema = (t: TranslationFunctionType) =>
  object().shape({
    targets: array().min(1, t('error.requiredField')),
  });
